<template>
    <page padding centered>
        <div class="row full-width">
            <div class="offset-xs-2 col-xs-8 col-md-4 offset-md-4">
                <img src="../../../img/identity/not-found.png" width="100%" :alt="'404 - ' + $T('page not found')"/>
            </div>
            <div class="offset-xs-2 col-xs-8 col-md-4 offset-md-4 text-center justify-center ">

                <q-btn no-caps color="primary" v-close-overlay class="full-width super-hover"
                       :label="$T('voltar ao Inicio')" link to="/desporto"></q-btn>

            </div>

        </div>
    </page>
</template>

<script>
    import {QBtn} from 'quasar-framework'
    export default {
        layout: 'default',
        name: 'NotFound',
        components:{
            QBtn
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/404.vue